import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const recoveryFeatures = [
  { icon: 'ri-timer-flash-line', title: 'Dakikalar İçinde Tam Kurtarma', desc: 'Tüm sisteminizi güvenli bir duruma hızlıca geri yükleyin; sisteminizi iyileştirin ve operasyonları dakikalar içinde yeniden başlatın.' },
  { icon: 'ri-shield-check-line', title: 'Sertleştirilmiş İşletim Sistemi', desc: 'VergeOS\'un sertleştirilmiş işletim sistemi verilerinizin güvenli ve kurtarılabilir kalmasını sağlar.' },
  { icon: 'ri-alarm-warning-line', title: 'Proaktif Saldırı Tespiti', desc: 'Proaktif uyarı sistemi potansiyel bir saldırı konusunda sizi önceden bilgilendirir.' },
  { icon: 'ri-shield-flash-line', title: 'En Sofistike Tehditlere Karşı', desc: 'En gelişmiş fidye yazılımı tehditlerinden bile hızlı kurtarma imkânı.' },
];

const cloneFeatures = [
  'Kesintisiz geri almalar için sınırsız değişmez klon kullanın',
  'Fidye yazılımı saldırılarına karşı alan tasarruflu kopyalar oluşturun',
  'Yalnızca veri korumasının ötesine geçin; dakikalar içinde fidye yazılımından tamamen kurtulun',
];

const detectionFeatures = [
  'Potansiyel fidye yazılımı saldırılarını proaktif olarak tespit edip karşılık verin',
  'Anomali tespiti için VergeOS dosya sistemi kontrolünden yararlanın',
  'Doğrulanabilirlik ve kurtarılabilirlik için Honeypot\'lar oluşturun',
  'Saldırılara hızlı tepki vermek için anında uyarı alın',
];

const vergePowers = [
  { icon: 'ri-cpu-line', title: 'Birleşik Altyapı', desc: 'Sanallaştırma, depolama ve ağı tek akıcı çözümde birleştirir.' },
  { icon: 'ri-expand-line', title: 'Daha Fazla Ölçeklenebilirlik', desc: 'Mevcut donanımda daha yüksek iş yükü yoğunluğu.' },
  { icon: 'ri-money-dollar-circle-line', title: '%50 Daha Az Maliyet', desc: 'Diğer rakip çözümlerden en az %50 daha ekonomik.' },
  { icon: 'ri-settings-line', title: 'Kolay Yönetim', desc: 'Kullanıcı dostu arayüz ve kapsamlı yönetim araçları.' },
];

const iofortifyJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'ioFortify',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'ioFortify ile fidye yazılımına karşı altyapı güvenliği. Değişmez anlık görüntüler, 256-bit şifreleme ve güvenlik sertleştirme.',
  url: `${SITE_URL}/iofortify`,
};

export default function IoFortifyPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="ioFortify | Fidye Yazılımı Koruması | VergeOS Güvenlik"
        description="ioFortify ile fidye yazılımına karşı altyapı güvenliği. Değişmez anlık görüntüler, 256-bit dinlenme halinde şifreleme ve sertleştirilmiş işletim sistemi."
        keywords="ioFortify, güvenlik, ransomware koruması, fidye yazılımı, değişmez snapshot, VergeOS, şifreleme"
        canonicalPath="/iofortify"
        jsonLd={iofortifyJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">Özellikler</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">ioFortify</span>
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Hızlı Fidye Yazılımı Müdahalesi</p>
            <p className="text-gray-400 text-sm mb-8 max-w-2xl mx-auto">Verilerinizi Geri Alın. Kontrolü Geri Kazanın.</p>
          </div>
        </section>

        {/* Intro */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Eşsiz, Bütünsel Kurtarma Gücü</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">VergeIO'nun ioFortify ile eşi benzeri görülmemiş kurtarma yeteneklerini deneyimleyin. Yalnızca verilerinizi değil, tüm veri merkezinizi koruyun ve operasyonlarınızı dakikalar içinde yeniden başlatın.</p>
                <ul className="space-y-3">
                  {recoveryFeatures.slice(0, 2).map(f => (
                    <li key={f.title} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>
                      <span><strong className="text-[#1e293b]">{f.title}:</strong> {f.desc}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/6004203034ff8d6ede2ec14a1c552418.jpg" alt="ioFortify Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Business Continuity */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=business%20continuity%20recovery%20diagram%20showing%20production%20environment%20DR%20on-premise%20and%20off-site%20DR%20sites%20with%20VergeOS%20minimizing%20downtime%20after%20ransomware%20attack%2C%20enterprise%20disaster%20recovery%20flow%20with%20orange%20and%20dark%20colors%20technical%20professional%20visualization&width=580&height=400&seq=iofortify_biz1&orientation=landscape" alt="İş Sürekliliği" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Kesinti Süresini Minimize Edin, İş Sürekliliğini Sağlayın</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">Fidye yazılımı saldırısından kurtarma iş sürekliliğini korumak için kritiktir. ioFortify, sistemlerin, uygulamaların ve dosyaların hızlı ve kapsamlı kurtarılmasını kolaylaştırır; kuruluşların kesinti süresini dramatik biçimde azaltmasını sağlar.</p>
                <p className="text-gray-600 mb-6 leading-relaxed">ioFortify, kesintisiz üretkenlik, aksamadan devam eden operasyonlar ve piyasadaki en ekonomik yedekliliği sağlar.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Clone Features */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Alan Verimli Klonlar ile Zahmetsiz Geri Yükleme</h2>
                <ul className="space-y-3 mb-6">
                  {cloneFeatures.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=immutable%20clones%20visualization%20showing%20ransomware-proof%20space%20efficient%20copies%20of%20VMs%20stored%20in%20VergeOS%20with%20rollback%20capability%2C%20data%20protection%20concept%20with%20unchangeable%20snapshots%20dark%20background%20orange%20highlights%20professional%20cybersecurity%20visualization&width=580&height=380&seq=iofortify_clone1&orientation=landscape" alt="ioFortify Klonlar" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Detection */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=proactive%20ransomware%20attack%20detection%20system%20showing%20VergeOS%20file%20system%20anomaly%20detection%20with%20honeypots%20and%20real-time%20alerts%2C%20cybersecurity%20monitoring%20dashboard%20with%20threat%20visualization%20orange%20and%20dark%20background%20professional%20enterprise%20security%20technology&width=580&height=400&seq=iofortify_detect1&orientation=landscape" alt="ioFortify Tehdit Tespiti" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-6">Proaktif Saldırı Tespiti ve Anında Uyarılar</h2>
                <ul className="space-y-3">
                  {detectionFeatures.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* VergeOS Powers */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-4">Altyapınızı VergeOS ile Güçlendirin</h2>
            <p className="text-gray-600 text-center mb-12 text-sm max-w-2xl mx-auto">VergeOS, eski HCI yapılandırmalarının sınırlamalarını tek akıcı yazılım çözümüne sanallaştırma, depolama ve ağı ultra entegre ederek aşar.</p>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {vergePowers.map(p => (
                <div key={p.title} className="bg-[#f8fafc] rounded-lg border border-gray-100 p-6 text-center">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mx-auto mb-4"><i className={`${p.icon} text-2xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{p.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">ioFortify ile Altyapınızı Koruyun</h2>
            <p className="text-gray-400 mb-8 text-sm">Fidye yazılımı korumasını ve hızlı kurtarma yeteneklerini nasıl sağlayabileceğinizi öğrenin.</p>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
